import { addNarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { useWidgetPillsAndFilters } from 'hooks/useWidgetPillsAndFilters';

import { useQueryGetProductivityRiskKPI } from 'api/queries/getProductivityRiskKPI.query';

import { usePinboardWidgetWrapperContext } from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/context/widgetWrapperContext';

export type UseProductivityRiskKPIProvider = ReturnType<typeof useProductivityRiskKPIProvider>;

interface Props {
    componentKey: string;
    widgetId?: string;
    latestVersionId?: number | undefined;
    compareVersionId?: number | undefined;
    globalFilterData: any;
    localFilters: any;
    contractId: number | null | undefined;
}

export const useProductivityRiskKPIProvider = ({
    widgetId,
    latestVersionId,
    localFilters,
    globalFilterData,
    compareVersionId,
    componentKey,
    contractId,
}: Props) => {
    const { isGenerativeAi } = usePinboardWidgetWrapperContext();
    const isInPinboard = Boolean(widgetId);
    const source = isInPinboard ? localFilters : { ...globalFilterData };

    const { filters, pills } = useWidgetPillsAndFilters({ widgetId, latestVersionId, source });

    const getProductivityRiskKPIPayload = {
        compareVersionId,
        latestVersionId,
        contractId,
        filter: {
            filters,
        },
        ...addNarrativeRequest(isGenerativeAi, componentKey, widgetId),
    };

    const getProductivityRiskKPI = useQueryGetProductivityRiskKPI(getProductivityRiskKPIPayload);

    return {
        ui: {
            state: {
                activityCodes: source?.activityCodes,
                milestoneFragnet: source?.milestoneFragnet,
                tags: source?.tags,
                wbs: source?.wbs,
            },
            pills: pills,
        },
        api: {
            getProductivityRiskKPI: {
                instance: getProductivityRiskKPI,
                payload: getProductivityRiskKPIPayload,
            },
        },
    };
};
